/**************************************************************************************************************************************************
*   MODULE NAME     :  HomeApi
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  11-02-2021
*   DESCRIPTION     :  Dashboard API class
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import axios from "axios";
import config from "../config.json";
import ApiBase from "./ApiBase";

class HomeApi {

  static loadGlobalDashboard = async () => {
    let payload = {action: "getGlobalDashboardData",typeId: 1};
    const response = await ApiBase.post(`${config.Backend_URL}/search`,payload);
    return response;
  }

  static loadGlobalDashboardDetails = async (datatype, site, paginationData) => {
    let payload = {action: "getGlobalDashboardDetails", datatype, site, paginationData};
    const response = await ApiBase.post(`${config.Backend_URL}/search`, payload);
    return response; 
  }
  static loadAllDashboardResults = async (datatype, site) => {
    let payload = {action: "getAllDashboardResults", datatype, site};
    const response = await ApiBase.post(`${config.Backend_URL}/search`, payload);
    return response; 
  }
  static sendGlobalDashboardEmail = async (payload) => {
    payload["action"] = "sendGlobalDashboardEmail";
    const response = await ApiBase.post(`${config.Backend_URL}/email`, payload);
    return response;
  }
  static sendJapanDashboardEmail = async (payload) => {
    payload["action"] = "sendJapanDashboardEmail";
    const response = await ApiBase.post(`${config.Backend_URL}/email`, payload);
    return response;
  }
}


export default HomeApi;
